export const Forum = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_293_24359)">
      <path
        d="M14 9.33333V14H9.33333C7.60958 14 6.10458 13.0579 5.29667 11.6643C5.74525 11.6608 6.18217 11.6112 6.6045 11.5197C7.24675 12.3194 8.23025 12.8333 9.33333 12.8333H12.8333V9.33333C12.8333 8.23025 12.3194 7.24675 11.5197 6.6045C11.6107 6.18217 11.6608 5.74525 11.6643 5.29667C13.0579 6.10458 14 7.60958 14 9.33333ZM5.25 10.5H0V5.25C0 2.35492 2.3555 0 5.25 0C8.1445 0 10.5 2.35492 10.5 5.25C10.5 8.14508 8.1445 10.5 5.25 10.5ZM9.33333 5.25C9.33333 2.99892 7.50167 1.16667 5.25 1.16667C2.99833 1.16667 1.16667 2.99892 1.16667 5.25V9.33333H5.25C7.50167 9.33333 9.33333 7.50108 9.33333 5.25ZM5.25 4.375C4.767 4.375 4.375 4.767 4.375 5.25C4.375 5.733 4.767 6.125 5.25 6.125C5.733 6.125 6.125 5.733 6.125 5.25C6.125 4.767 5.733 4.375 5.25 4.375ZM2.91667 4.375C2.43367 4.375 2.04167 4.767 2.04167 5.25C2.04167 5.733 2.43367 6.125 2.91667 6.125C3.39967 6.125 3.79167 5.733 3.79167 5.25C3.79167 4.767 3.39967 4.375 2.91667 4.375ZM7.58333 4.375C7.10033 4.375 6.70833 4.767 6.70833 5.25C6.70833 5.733 7.10033 6.125 7.58333 6.125C8.06633 6.125 8.45833 5.733 8.45833 5.25C8.45833 4.767 8.06633 4.375 7.58333 4.375Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_24359">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
